import React from 'react';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import { Navigate } from 'react-router-dom';
import { paths } from '@/app/paths';
import { ImportIconBadge } from '@/components/icons/ImportIconBadge';
import { UsersListPage } from './UsersListPage';
import { UserImportPage } from './import/UserImportPage';
import { UserImportRedirect } from './import/UserImportRedirect';

export const usersRoutes = [
	{
		path: 'users',
		element: <UsersListPage />,
		handle: { title: 'Users', icon: <GroupOutlinedIcon /> },
		// Render nothing: the list page always renders UserDrawer and opens it on these routes
		// (a new user, or one user), so the drawer can slide in and out (null, not left out, so
		// the router doesn't warn)
		children: [
			{ path: 'new', element: null },
			{ path: ':userId', element: null },
		],
	},
	{
		// In the side nav's Import section (usersImportNavItem)
		path: 'import/users',
		element: <UserImportPage />,
		// The side nav's icon (with the import arrow), at the header's size. Sized here, as the
		// header only sizes an icon that's its direct child, not one inside the badge.
		handle: {
			title: 'Import users',
			icon: (
				<ImportIconBadge>
					<GroupOutlinedIcon sx={{ fontSize: 40 }} />
				</ImportIconBadge>
			),
		},
	},
	{
		// The page's old address; ranked above users/:userId as it's static
		path: 'users/import',
		element: <Navigate to={`${paths.admin}/import/users`} replace />,
	},
	{
		// Reports moved to the import history
		path: 'users/import/:importId',
		element: <UserImportRedirect />,
	},
];

export const usersNavItem = {
	text: 'Users',
	icon: <GroupOutlinedIcon sx={{ fontSize: 30 }} />,
	link: `${paths.admin}/users`,
};

/** The Import section's Users item: the user import page. */
export const usersImportNavItem = {
	text: 'Users',
	icon: (
		<ImportIconBadge>
			<GroupOutlinedIcon sx={{ fontSize: 30 }} />
		</ImportIconBadge>
	),
	link: `${paths.admin}/import/users`,
};
